import React from 'react';
import './style.scss';

export default React.forwardRef(({ className=null, label=null, value=null, disabled=false, ...props }, ref) => <div className={`zt-inputs--info ${disabled? 'zt-inputs--info--disabled':''} ${className ? className : ''}`}>
    { !!label &&
        <div className='zt-inputs--info__label'><span className='zt-p3'>{label}</span></div>
    }
    <div className='zt-inputs--info__value'>{value}</div>
 </div>);